import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, pure, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import createFocusDecorator from 'final-form-focus';
import { withRouter } from 'react-router-dom';

import * as actions from 'actions';

import Form from './Form';
import { handlers, utils } from './shared';

const propTypes = {
  disabled: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    application: PropTypes.shape({
      borrower: PropTypes.objectOf(PropTypes.any),
      dataEntryStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      token: PropTypes.string,
      type: PropTypes.string,
      signatureVersion: PropTypes.string,
    }),
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  updateApplicationFifthStep: PropTypes.func.isRequired,
};

const focusOnError = createFocusDecorator();

function Signature(props) {
  const { disabled, initialValues, loading, updateApplicationFifthStep } = props;
  const { signatureVersion, acknowledgmentCheckboxesVersion } = initialValues.application;
  return (
    <FinalForm
      disabled={disabled}
      signatureVersion={signatureVersion}
      acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion}
      onSubmit={updateApplicationFifthStep}
      decorators={[focusOnError]}
      initialValues={initialValues}
      subscription={{ submitting: true, pristine: true }}
      loading={loading}
      component={Form}
    />
  );
}

Signature.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
  return {
    fetchApplicationFifthStep: bindActionCreators(actions.fetchApplicationFifthStep, dispatch),
    updateApplicationFifthStep: bindActionCreators(actions.updateApplicationFifthStep, dispatch),
  };
}

const enhance = compose(
  withRouter,
  connect(null, mapDispatchToProps),
  withState('loading', 'setLoading', false),
  withState('initialValues', 'setInitialValues', utils.setDefaultInitialValues()),
  withState('disabled', 'setDisabled', false),
  withHandlers({
    setDisabledByInitValues: handlers.setDisabledByInitValues,
    setCheck: handlers.setCheck,
  }),
  withHandlers({
    mergeInitialValues: handlers.mergeInitialValues,
  }),
  lifecycle({
    async componentDidMount() {
      const { match, fetchApplicationFifthStep, mergeInitialValues, setLoading } = this.props;
      const { token } = match.params;
      setLoading(true);
      await fetchApplicationFifthStep(token).then(mergeInitialValues);
      setLoading(false);
    },
  }),
  pure,
);

export default enhance(Signature);
